"use client";

import { useCallback, useMemo, useState, type ReactNode } from "react";
import {
  BreadcrumbContext,
  DEFAULT_BREADCRUMBS,
  areBreadcrumbsEqual,
  type BreadcrumbItem,
} from "./breadcrumb-defs";

export type { BreadcrumbItem };

export const BreadcrumbProvider = ({ children }: { children: ReactNode }) => {
  const [items, setItemsState] = useState<BreadcrumbItem[]>(DEFAULT_BREADCRUMBS);

  const setItems = useCallback((nextItems: BreadcrumbItem[]) => {
    setItemsState((previous) => {
      const normalized = nextItems.length > 0 ? nextItems : DEFAULT_BREADCRUMBS;
      return areBreadcrumbsEqual(previous, normalized) ? previous : normalized;
    });
  }, []);

  const value = useMemo(() => ({ items, setItems }), [items, setItems]);

  return <BreadcrumbContext.Provider value={value}>{children}</BreadcrumbContext.Provider>;
};
